import View from './View';

export { default as View } from './View';
export { default as getSettingsScreenContentStyles } from './styles';

export default View;
